import { StyleSheet, View } from 'react-native';

import { setLocale, useLocale } from '../hooks/useLocale';
import { staticTranslation } from '../services/staticTranslations';
import { Languages } from '../util/enums';
import { Paragraph, ParagraphSizes } from './paragraph';
import { RadioButton } from './radioButton';

const AnonymousLanguageToggle = (props) => {
  const locale = useLocale();
  return (
    <View
      style={[styles.altLanguageToggle, props.style || {}]}
      role="radiogroup"
      accessibilityRole="radiogroup"
      aria-label={staticTranslation(locale, 'Language Preference:')}
    >
      <RadioButton
        selected={locale === Languages.english}
        style={{ marginRight: 10 }}
        action={() => setLocale(Languages.english, true)}
      >
        <Paragraph size={ParagraphSizes.TINY}>
          {Languages.displayLanguage(Languages.english)}
        </Paragraph>
      </RadioButton>
      <RadioButton
        selected={locale === Languages.french}
        style={{ marginRight: 10 }}
        action={() => setLocale(Languages.french, true)}
      >
        <Paragraph size={ParagraphSizes.TINY}>
          {Languages.displayLanguage(Languages.french)}
        </Paragraph>
      </RadioButton>
      <RadioButton
        selected={locale === Languages.spanish}
        action={() => setLocale(Languages.spanish, true)}
      >
        <Paragraph size={ParagraphSizes.TINY}>
          {Languages.displayLanguage(Languages.spanish)}
        </Paragraph>
      </RadioButton>
    </View>
  );
};

const styles = StyleSheet.create({
  altLanguageToggle: {
    justifyContent: 'center',
    marginTop: 20,
    flexDirection: 'row'
  }
});

export { AnonymousLanguageToggle };
